package kz.dentalcrm.app.screens.patients.detail

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.kizitonwose.calendar.core.now
import compose.icons.FeatherIcons
import compose.icons.feathericons.Calendar
import compose.icons.feathericons.ChevronLeft
import compose.icons.feathericons.Phone
import compose.icons.feathericons.User
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.address
import dentalcrm.composeapp.generated.resources.appointment_doctor_label
import dentalcrm.composeapp.generated.resources.birthday
import dentalcrm.composeapp.generated.resources.city
import dentalcrm.composeapp.generated.resources.contact_info
import dentalcrm.composeapp.generated.resources.delete
import dentalcrm.composeapp.generated.resources.empty_name_err
import dentalcrm.composeapp.generated.resources.empty_surname_err
import dentalcrm.composeapp.generated.resources.idn
import dentalcrm.composeapp.generated.resources.idn_number
import dentalcrm.composeapp.generated.resources.main_info
import dentalcrm.composeapp.generated.resources.name
import dentalcrm.composeapp.generated.resources.parenthesis
import dentalcrm.composeapp.generated.resources.patient_appointments_empty
import dentalcrm.composeapp.generated.resources.patient_detail
import dentalcrm.composeapp.generated.resources.phone
import dentalcrm.composeapp.generated.resources.save
import dentalcrm.composeapp.generated.resources.services_total_label
import dentalcrm.composeapp.generated.resources.surname
import dentalcrm.composeapp.generated.resources.appointments_tab
import dentalcrm.composeapp.generated.resources.details
import dentalcrm.composeapp.generated.resources.gender
import dentalcrm.composeapp.generated.resources.work_place
import dentalcrm.composeapp.generated.resources.work_position
import io.github.alexzhirkevich.compottie.LottieCompositionSpec
import io.github.alexzhirkevich.compottie.rememberLottieComposition
import io.github.alexzhirkevich.compottie.rememberLottiePainter
import kotlinx.collections.immutable.PersistentList
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.core.ui.UiStateScaffold
import kz.dentalcrm.app.core.ui.components.BirthDayDialog
import kz.dentalcrm.app.core.ui.components.ChipItem
import kz.dentalcrm.app.core.ui.components.ContentButton
import kz.dentalcrm.app.core.ui.components.GenderSelectionDialog
import kz.dentalcrm.app.core.ui.components.SegmentText
import kz.dentalcrm.app.core.ui.components.SegmentedControl
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.core.ui.components.UIIconBackButton
import kz.dentalcrm.app.core.ui.components.UISelfTextInput
import kz.dentalcrm.app.core.ui.components.UITextInputClickable
import kz.dentalcrm.app.core.ui.utils.MaskVisualTransformation
import kz.dentalcrm.app.core.utils.formatBirthdayToDisplay
import kz.dentalcrm.app.core.utils.formatToBackend
import kz.dentalcrm.app.core.utils.getMonths
import kz.dentalcrm.app.core.utils.getMonthsShort
import kz.dentalcrm.app.core.utils.parseBackendDate
import kz.dentalcrm.app.data.network.response_model.AppointmentResponse
import kz.dentalcrm.app.navigation.AppNavigator
import kz.dentalcrm.app.navigation.EditAppointmentRoute
import kz.dentalcrm.app.navigation.PatientDetailRoute
import kz.dentalcrm.app.screens.patients.detail.mvi.PatientDetailSideEffect
import kz.dentalcrm.app.screens.patients.detail.mvi.PatientDetailState
import kz.dentalcrm.app.screens.patients.detail.mvi.PatientDetailViewEvent
import kz.dentalcrm.app.screens.ui.ContentHeader
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.ExperimentalTime

@Composable
fun PatientDetailScreen(
    patientId: Int,
) {
    val navigator: AppNavigator = koinInject()
    val viewModel: PatientDetailViewModel = koinViewModel()
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        val state by viewModel.viewState.collectAsState()
        val detailsLabel = stringResource(Res.string.details)
        val appointmentsLabel = stringResource(Res.string.appointments_tab)
        val segments = remember(detailsLabel, appointmentsLabel) { listOf(detailsLabel, appointmentsLabel) }
        var selectedSegment by remember { mutableStateOf(0) }
        val coroutineScope = rememberCoroutineScope()
        val pagerState = rememberPagerState { 2 }

        LaunchedEffect(
            "screen_first"
        ) {
            viewModel.setEvent(PatientDetailViewEvent.LoadData(patientId))
        }

        LaunchedEffect(
            "screen_launch"
        ) {
            viewModel.effect.onEach { effect ->
                when (effect) {
                    is PatientDetailSideEffect.DeleteSuccess -> {
                        navigator.navigateBackWithResult(
                            key = PatientDetailRoute.RESULT_KEY,
                            result = PatientDetailRoute.Result(patientId = patientId, deleted = true)
                        )
                    }
                    is PatientDetailSideEffect.UpdateSuccess -> {
                        navigator.navigateBackWithResult(
                            key = PatientDetailRoute.RESULT_KEY,
                            result = PatientDetailRoute.Result(patientId = patientId, updated = true)
                        )
                    }
                    is PatientDetailSideEffect.ShowError -> {
                        // TODO: Show error message to user (e.g., Toast or Snackbar)
                    }
                }
            }.collect()
        }

        UiStateScaffold(
            modifier = Modifier.fillMaxSize(),
            isLoading = state.screenState is ScreenState.Loading
        ) {
            Column(
                modifier = Modifier.fillMaxSize()
                    .statusBarsPadding()
            ) {
                ContentHeader(
                    modifier = Modifier.fillMaxWidth()
                        .padding(horizontal = 12.dp),
                    text = stringResource(Res.string.patient_detail),
                    leadingContent = {
                        UIIconBackButton(
                            onClick = {
                                navigator.navigateUp()
                            }
                        )
                    }
                )
                Box(
                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp)
                        .padding(bottom = 12.dp)
                ) {
                    SegmentedControl(
                        segments = segments,
                        selectedSegment = segments[selectedSegment],
                        backgroundColor = DefaultTheme.colors.surfaceAlternative,
                        onSegmentSelected = { item ->
                            coroutineScope.launch {
                                val index = segments.indexOf(item)
                                selectedSegment = index
                                pagerState.animateScrollToPage(index)
                            }
                        }
                    ) { titleId, selected ->
                        SegmentText(titleId, selected)
                    }
                }
                HorizontalPager(
                    modifier = Modifier
                        .weight(1f),
                    contentPadding = PaddingValues(horizontal = 0.dp),
                    state = pagerState,
                    userScrollEnabled = false,
                    verticalAlignment = Alignment.Top
                ) { page ->
                    when (page) {
                        0 -> {
                            if (state.screenState is ScreenState.Idle) {
                                PatientDetailContent(
                                    modifier = Modifier.weight(1f),
                                    state = state,
                                    onEvent = viewModel::setEvent
                                )
                            }
                        }
                        1 -> {
                            PatientAppointmentsContent(
                                modifier = Modifier.weight(1f),
                                appointments = state.patientAppointments,
                                onAppointmentClick = { appointmentId ->
                                    navigator.navigate(EditAppointmentRoute(appointmentId))
                                }
                            )
                        }
                    }
                }

            }
        }

    }
}

@OptIn(ExperimentalTime::class)
@Composable
fun PatientDetailContent(
    modifier: Modifier = Modifier,
    state: PatientDetailState,
    onEvent: (PatientDetailViewEvent) -> Unit
) {
    var birthdayDialog by remember { mutableStateOf(false) }
    var genderDialog by remember { mutableStateOf(false) }

    if (birthdayDialog) {
        val currentDate = state.patient?.birth_date?.parseBackendDate()
            ?: state.birth_day_selected
            ?: LocalDate.now()
        
        BirthDayDialog(
            defaultTime = currentDate,
            onDismissRequest = { birthdayDialog = false },
            onDateSelected = { date ->
                val formattedDate = date.formatToBackend()
                onEvent(PatientDetailViewEvent.UpdateBirthday(
                    value = formattedDate,
                    formatted = formattedDate
                ))
            }
        )
    }

    if (genderDialog) {
        GenderSelectionDialog(
            onDismissRequest = { genderDialog = false },
            onGenderSelected = { gender ->
                onEvent(PatientDetailViewEvent.UpdateGender(gender))
            }
        )
    }

    LazyColumn(
        modifier = modifier.fillMaxSize()
            .padding(horizontal = 16.dp),
        state = rememberLazyListState()
    ) {
        item {
            Spacer(modifier = Modifier.height(16.dp))
        }
        item {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .heightIn(min = 44.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceBackgroundSecondary,
                        shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
                    ),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 8.dp),
                    text = stringResource(Res.string.main_info),
                    color = DefaultTheme.colors.onSurface,
                    style = DefaultTheme.typography.bodyLargeMedium,
                )
            }
            InputItem(
                label = stringResource(Res.string.name),
                textError =
                    if (state.patient?.name.orEmpty().isEmpty()) {
                        stringResource(Res.string.empty_name_err)
                    } else "",
                value = state.patient?.name.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateName(it))
            }
            InputItem(
                label = stringResource(Res.string.surname),
                textError = if (state.patient?.surname.orEmpty().isEmpty()) {
                    stringResource(Res.string.empty_surname_err)
                } else "",
                value = state.patient?.surname.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateSurname(it))
            }
            InputItem(
                label = stringResource(Res.string.parenthesis),
                value = state.patient?.patronymic.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdatePatronymic(it))
            }
            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceBackgroundSecondary)
                    .padding(horizontal = 16.dp, vertical = 4.dp)
                    .padding(bottom = 4.dp)
            ) {
                UITextInputClickable(
                    modifier = Modifier
                        .fillMaxWidth(),
                    leadingIcon = FeatherIcons.User,
                    defaultValue = state.patient?.gender.orEmpty(),
                    label = stringResource(Res.string.gender),
                    valueChanged = { },
                    onClicked = {
                        genderDialog = true
                    }
                )
            }
            Box(
                modifier = Modifier.fillMaxWidth()
                    .background(color = DefaultTheme.colors.surfaceBackgroundSecondary)
                    .padding(horizontal = 16.dp, vertical = 4.dp)
            ) {
                UITextInputClickable(
                    modifier = Modifier
                        .fillMaxWidth(),
                    leadingIcon = FeatherIcons.Calendar,
                    isOnlyNumbers = false,
                    defaultValue = state.patient?.birth_date?.formatBirthdayToDisplay(
                        getMonths()
                    ) ?: "",
                    label = stringResource(Res.string.birthday),
                    valueChanged = { },
                    onClicked = {
                        birthdayDialog = true
                    }
                )
            }
            Box(
                modifier = Modifier.fillMaxWidth()
                    .height(20.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceBackgroundSecondary,
                        shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp)
                    )
            )
        }
        item {
            Spacer(modifier = Modifier.height(24.dp))
        }
        item {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .heightIn(min = 44.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceBackgroundSecondary,
                        shape = RoundedCornerShape(topStart = 24.dp, topEnd = 24.dp)
                    ),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 8.dp),
                    color = DefaultTheme.colors.onSurface,
                    text = stringResource(Res.string.contact_info),
                    style = DefaultTheme.typography.bodyLargeMedium,
                )
            }
            PhoneInputItem(
                label = stringResource(Res.string.phone),
                textError = "",
                value = state.patient?.phone.orEmpty()
            ) { value ->
                onEvent(PatientDetailViewEvent.UpdatePhone(value))
            }
            InputItem(
                label = stringResource(Res.string.idn),
                value = state.patient?.id_card.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateIdn(it))
            }
            InputItem(
                label = stringResource(Res.string.idn_number),
                value = state.patient?.id_number.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateIdnNumber(it))
            }
            InputItem(
                label = stringResource(Res.string.city),
                value = state.patient?.city.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateCity(it))
            }
            InputItem(
                label = stringResource(Res.string.address),
                value = state.patient?.address.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateAddress(it))
            }
            InputItem(
                label = stringResource(Res.string.work_place),
                value = state.patient?.workplace.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdateWorkplace(it))
            }
            InputItem(
                label = stringResource(Res.string.work_position),

                value = state.patient?.position.orEmpty()
            ) {
                onEvent(PatientDetailViewEvent.UpdatePosition(it))
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .background(
                        color = DefaultTheme.colors.surfaceBackgroundSecondary
                    )
                    .padding(horizontal = 16.dp)
                    .padding(top = 24.dp)
            ) {
                UIButton(
                    modifier = Modifier.weight(1f),
                    text = stringResource(Res.string.delete),
                    containerColor = DefaultTheme.colors.error,
                    onClick = {
                        onEvent(PatientDetailViewEvent.Delete)
                    }
                )
                Spacer(modifier = Modifier.width(16.dp))
                UIButton(
                    modifier = Modifier.weight(1f),
                    text = stringResource(Res.string.save),
                    onClick = {
                        onEvent(PatientDetailViewEvent.Update)
                    }
                )
            }
            Box(
                modifier = Modifier.fillMaxWidth()
                    .height(16.dp)
                    .background(
                        color = DefaultTheme.colors.surfaceBackgroundSecondary,
                        shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp)
                    )
            )
        }
        item {
            Spacer(
                modifier = Modifier.height(56.dp)
                    .navigationBarsPadding()
            )
        }
    }
}


@Composable
fun InputItem(
    textError: String? = null,
    icon: ImageVector = FeatherIcons.User,
    isImeDone: Boolean = false,
    value: String = "",
    label: String = "",
    onValueChange: (String) -> Unit,
) {
    Box(
        modifier = Modifier.fillMaxWidth()
            .background(color = DefaultTheme.colors.surfaceBackgroundSecondary)
    ) {
        UISelfTextInput(
            modifier = Modifier
                .padding(horizontal = 16.dp, vertical = 8.dp)
                .fillMaxWidth(),
            leadingIcon = icon,
            value = value,
            label = label,
            keyboardOptions = KeyboardOptions(imeAction = if (isImeDone) ImeAction.Done else ImeAction.Next).copy(
                keyboardType = KeyboardType.Text
            ),
            errorText = textError.orEmpty(),
            isOnError = textError.isNullOrEmpty().not(),
            valueChanged = onValueChange
        )
    }
}

@Composable
fun PhoneInputItem(
    textError: String? = null,
    value: String = "",
    label: String = "",
    onValueChange: (String) -> Unit,
) {
    Box(
        modifier = Modifier.fillMaxWidth()
            .background(color = DefaultTheme.colors.surfaceBackgroundSecondary)
    ) {
        UISelfTextInput(
            modifier = Modifier
                .padding(horizontal = 16.dp, vertical = 8.dp)
                .fillMaxWidth(),
            leadingIcon = FeatherIcons.Phone,
            maxLength = 10,
            isOnlyNumbers = true,
            keyboardType = KeyboardType.Phone,
            visualTransformation = MaskVisualTransformation("+7 ###-###-####"),
            value = value,
            label = stringResource(Res.string.phone),
            valueChanged = onValueChange
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PatientAppointmentsContent(
    modifier: Modifier = Modifier,
    appointments: PersistentList<AppointmentResponse>,
    onAppointmentClick: (Int) -> Unit
) {
    val noComposition by rememberLottieComposition {
        LottieCompositionSpec.JsonString(
            Res.readBytes("files/no_history.json").decodeToString()
        )
    }
    val monthsShort = getMonthsShort()

    if (appointments.isEmpty()) {
        Box(
            modifier = modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Image(
                    modifier = Modifier.size(120.dp),
                    painter = rememberLottiePainter(
                        composition = noComposition,
                        iterations = 1
                    ),
                    contentDescription = null
                )
                Spacer(modifier = Modifier.height(16.dp))
                Text(
                    text = stringResource(Res.string.patient_appointments_empty),
                    style = DefaultTheme.typography.bodyMediumRegular,
                    color = DefaultTheme.colors.onSurface
                )
            }
        }
    } else {
        LazyColumn(
            modifier = modifier
                .fillMaxSize()
                .padding(horizontal = 16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
            contentPadding = PaddingValues(vertical = 16.dp)
        ) {
            items(
                items = appointments,
                key = { it.id }
            ) { appointment ->
                PatientAppointmentItem(
                    appointment = appointment,
                    monthsShort = monthsShort,
                    onClick = { onAppointmentClick(appointment.id) }
                )
            }
            item {
                Spacer(modifier = Modifier.height(56.dp).navigationBarsPadding())
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PatientAppointmentItem(
    appointment: AppointmentResponse,
    monthsShort: List<String>,
    onClick: () -> Unit
) {
    val formattedDate = appointment.starts_at?.formatAppointmentDate(monthsShort).orEmpty()
    val employeeName = appointment.employee?.let { employee ->
        "${employee.surname.orEmpty()} ${employee.name.orEmpty()}".trim()
    }.orEmpty()
    val totalPrice = appointment.services?.sumOf { service ->
        service.pivot?.actual_price ?: service.price ?: 0
    } ?: 0

    ContentButton(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(16.dp),
        onClick = onClick
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .background(
                    color = DefaultTheme.colors.surfaceAlternative,
                    shape = RoundedCornerShape(16.dp)
                )
                .padding(16.dp)
        ) {
            // Date
            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(
                    imageVector = FeatherIcons.Calendar,
                    contentDescription = null,
                    tint = DefaultTheme.colors.primary,
                    modifier = Modifier.size(16.dp)
                )
                Spacer(modifier = Modifier.width(8.dp))
                Text(
                    text = formattedDate,
                    style = DefaultTheme.typography.bodyMediumMedium,
                    color = DefaultTheme.colors.onSurface
                )
            }

            Spacer(modifier = Modifier.height(8.dp))

            // Doctor
            if (employeeName.isNotEmpty()) {
                Text(
                    text = "${stringResource(Res.string.appointment_doctor_label)} $employeeName",
                    style = DefaultTheme.typography.bodySmallRegular,
                    color = DefaultTheme.colors.onSurfaceVariant
                )
                Spacer(modifier = Modifier.height(12.dp))
            }

            // Services total
            Text(
                text = "${stringResource(Res.string.services_total_label)} $totalPrice ₸",
                style = DefaultTheme.typography.bodySmallMedium,
                color = DefaultTheme.colors.onSurface
            )

            // Services chips
            if (!appointment.services.isNullOrEmpty()) {
                Spacer(modifier = Modifier.height(8.dp))
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    appointment.services.forEach { service ->
                        ChipItem(
                            text = service.name.orEmpty(),
                            onRemove = {},
                        )
                    }
                }
            }
        }
    }
}

private fun String.formatAppointmentDate(monthsShort: List<String>): String {
    return try {
        // Format: "2026-02-08 16:10:00"
        val parts = this.split(" ")
        if (parts.size < 2) return this

        val datePart = parts[0]
        val timePart = parts[1]

        val dateParts = datePart.split("-")
        if (dateParts.size < 3) return this

        val year = dateParts[0].toIntOrNull() ?: return this
        val month = dateParts[1].toIntOrNull() ?: return this
        val day = dateParts[2].toIntOrNull() ?: return this

        val timeParts = timePart.split(":")
        val hour = timeParts.getOrNull(0) ?: "00"
        val minute = timeParts.getOrNull(1) ?: "00"

        val monthName = monthsShort.getOrNull(month - 1) ?: ""

        // Calculate day of week
        val dayOfWeek = getDayOfWeek(year, month, day)

        "$day $monthName $year в $hour:$minute ($dayOfWeek)"
    } catch (e: Exception) {
        this
    }
}

private fun getDayOfWeek(year: Int, month: Int, day: Int): String {
    // Zeller's congruence for Gregorian calendar
    var m = month
    var y = year
    if (m < 3) {
        m += 12
        y -= 1
    }
    val k = y % 100
    val j = y / 100
    val h = (day + (13 * (m + 1)) / 5 + k + k / 4 + j / 4 - 2 * j) % 7
    val dayIndex = ((h + 5) % 7) // Convert to Monday = 0
    return listOf("Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс").getOrNull(dayIndex) ?: ""
}
